<template>
  <div class="running-summary">
    <template v-if="!isHubOrder">
      <div class="row title">
        <div class="license">{{ license }}</div>
        <div class="desc">
          当前车上有<span class="red">{{ busOrderNum }}单</span>
        </div>
      </div>
      <div class="row">
        <img src="../../../assets/img-v2/ic_running_user.png" class="img" />
        <div class="label">{{ displayLabel }}</div>
        <img src="../../../assets/img-v2/ic_running_price.png" class="img2" />
        <div class="label">已支付{{ price }}元</div>
      </div>
    </template>
    <template v-else>
      <div v-if="license" class="row title">
        <div class="license">{{ license }}</div>
      </div>
      <div class="bottom">
        <div class="row">
          <img src="../../../assets/img-v2/ic_running_user.png" class="img" />
          <div class="label">{{ displayLabel }}</div>
          <img
            src="../../../assets/img-v2/ic_running_ticket.png"
            class="img2"
          />
          <div class="label">{{ hubBookingOrderDesc }}</div>
        </div>
        <div class="label">{{ hubOrderTimeDesc }}</div>
      </div>
    </template>
  </div>
</template>

<script>
import { fenToYuan } from "@/utils";

export default {
  name: "RunningSummary",
  props: {
    orderInfo: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {};
  },
  computed: {
    license() {
      const { busLicense } = this.orderInfo || {};
      return busLicense;
    },
    busOrderNum() {
      const { busOrderNum } = this.orderInfo || {};
      return busOrderNum || 0;
    },
    passengerCount() {
      const { singalNum = 1 } = this.orderInfo || {};
      return singalNum;
    },
    isGroupOrder() {
      const { isGroupOrder } = this.orderInfo || {};
      return isGroupOrder;
    },
    displayLabel() {
      return this.isGroupOrder ? "专车直达" : `${this.passengerCount}人乘车`;
    },
    price() {
      const { actualPrice } = this.orderInfo || {};
      return fenToYuan(actualPrice);
    },
    isHubOrder() {
      const { isHubOrder } = this.orderInfo || {};
      return isHubOrder || false;
    },
    hubBookingOrderDesc() {
      const { hubBookingOrderDesc } = this.orderInfo || {};
      return hubBookingOrderDesc || "";
    },
    hubOrderTimeDesc() {
      const { hubOrderTimeDesc } = this.orderInfo || {};
      return hubOrderTimeDesc || "";
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
.running-summary {
  padding: 20px 20px 16px 20px;
  .row {
    display: flex;
    align-items: center;
  }

  .title {
    justify-content: space-between;
    margin-bottom: 16px;
  }
  .license {
    font-family: zihun266hao-shenshihei, zihun266hao-shenshihei;
    font-weight: 500;
    font-size: 30px;
    color: #000000;
    line-height: 36px;
  }
  .desc {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 14px;
    color: #000000;
    line-height: 20px;
  }
  .red {
    color: #fe5959;
  }
  .label {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 12px;
    color: #000000;
    line-height: 16px;
  }
  .img {
    width: 16px;
    height: 16px;
  }
  .img2 {
    width: 16px;
    height: 16px;
    margin-left: 8px;
  }
  .bottom {
    display: flex;
    justify-content: space-between;
  }
}
</style>
